module.exports = __webpack_public_path__ + "img/acasialogo-ungu.e2209fb5.svg";